import React,{useState, useEffect}  from "react";
import { getEstadisticaPlanes } from "../../services/Reportes.js";

// components

export default function CardPageVisits({selectedDate, selectedDateEnd}) {
  const [dataDataC, setDataC] = useState([]);

      useEffect(()=>{
        const fetchData = async () => {
          const soliciData = await getEstadisticaPlanes(selectedDate,selectedDateEnd);
          
          if (soliciData) {
           // console.log(soliciData);
            setDataC(soliciData);
          }
  
        };
        fetchData();
      },[selectedDate,selectedDateEnd]); 
  
  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
        <div className="rounded-t mb-0 px-4 py-3 border-0">
          <div className="flex flex-wrap items-center">
            <div className="relative w-full px-4 max-w-full flex-grow flex-1">
              <h3 className="font-semibold text-base text-blueGray-700">
                Planes
              </h3>
            </div>
            <div className="relative w-full px-4 max-w-full flex-grow flex-1 text-right">
              <button
                className="bg-green-800 text-white active:bg-indigo-600 text-xs font-bold uppercase px-3 py-1 rounded outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                type="button"
              >
                Ver Detalle
              </button>
            </div>
          </div>
        </div>
        <div className="block w-full overflow-x-auto">
          {/* Projects table */}
          <table className="w-full bg-transparent border-collapse">
            <thead>
              <tr>
                <th className="px-6 bg-gray-100 text-gray-600 border border-gray-200 py-3 text-xs uppercase font-semibold text-left">
                  Nombre
                </th>
                <th className="px-6 bg-gray-100 text-gray-600 border border-gray-200 py-3 text-xs uppercase font-semibold text-left">
                  Valor
                </th>
                <th className="px-6 bg-gray-100 text-gray-600 border border-gray-200 py-3 text-xs uppercase font-semibold text-left">
                  Cantidad
                </th>
                <th className="px-6 bg-gray-100 text-gray-600 border border-gray-200 py-3 text-xs uppercase font-semibold text-left">
                  Total
                </th>
              </tr>
            </thead>
            <tbody>
              {dataDataC.map((item, index) => (
                <tr key={index}>
                  <td className="border-t border-gray-200 px-6 py-4 text-sm text-left">
                    {item.nombrePlan}
                  </td>
                  <td className="border-t border-gray-200 px-6 py-4 text-sm">
                    {item.valor.toLocaleString()}
                  </td>
                  <td className="border-t border-gray-200 px-6 py-4 text-sm">
                    {item.cantidad}
                  </td>
                  <td className="border-t border-gray-200 px-6 py-4 text-sm">
                    {(item.total || item.valor * item.cantidad).toLocaleString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

        </div>
      </div>
    </>
  );
}
